export interface TableRow {
  machineType: string;
  machineNumber: number;
  shift: "Day" | "Night";
  totalParts: number;
  totalSeconds: number;
}

export interface DayData {
  date: string;
  data: TableRow[];
}

const DARK_BLUE = "#0056b3"
const DARK_RED = "#b30000"
const DARK_GREEN = "#006600"
const DARK_ORANGE = "#cc8400"
const LIGHT_BLUE = "#4da3ff"
const LIGHT_RED = "#ff4d4d"
const LIGHT_GREEN = "#33cc33"
const LIGHT_ORANGE = "#ffc04d"

export const MACHINE_COLORS: Record<string, { day: string; night: string }> = {
  "CNC-1": { day: LIGHT_BLUE, night: DARK_BLUE },
  "CNC-2": { day: LIGHT_RED, night: DARK_RED },
  "CNC-3": { day: LIGHT_GREEN, night: DARK_GREEN },
  "CNC-4": { day: LIGHT_ORANGE, night: DARK_ORANGE },
  "Saw-1": { day: LIGHT_BLUE, night: DARK_BLUE },
  "Saw-2": { day: LIGHT_RED, night: DARK_RED },
  "Edge-1": { day: LIGHT_BLUE, night: DARK_BLUE },
  "Edge-2": { day: LIGHT_RED, night: DARK_RED },
};

export const FALLBACK_COLORS = { day: "#888888", night: "#BBBBBB" };

export function getMachineColor(
  machineType: string,
  machineNumber: number,
  shift: "Day" | "Night"
): string {
  const key = `${machineType}-${machineNumber}`;
  const colors = MACHINE_COLORS[key] ?? FALLBACK_COLORS;
  return shift === "Day" ? colors.day : colors.night;
}
